export function setLoggedInStatus(loggedInStatus){
    return {
        type: 'SET_LOGGED_IN_STATUS',
        status: loggedInStatus
    }
}

export function setLoggedInUser(user){
    return {
        type: 'SET_LOGGED_IN_USER',
        user: user
    }
}


// WEBPACK FOOTER //
// ./src/components/generic/actions.js